export default __webpack_public_path__ + "static/media/cleaning-mission.ef70e9c0.jpg";